<div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="row">{{ "raster-category.title" | translate }}</h2>
    <div *ngIf="topMenuIcons.length > 0">
      <button
          mat-raised-button
          [disabled]="
          !this.detailForm.valid ||
          !this.selectedTypeOfRaster ||
          this.selectedTypeOfRaster.length == 0 ||
          this.disableByProfile"
          (click)="save()"
        >
        <mat-icon [title]="this.saveIconTitle"> save </mat-icon>
        </button>
        <button
          mat-raised-button
          [disabled]="this.disableByProfile"
          *ngIf="this.id !== 'new'"
          (click)="deleteConfirm()"
        >
        <mat-icon [title]="this.deleteIconTitle"> delete </mat-icon>
        </button>
        <ng-container *ngFor="let action of topMenuIcons">
          <button
            mat-raised-button
            *ngIf="!action.hide"
            [routerLink]="action.routerLink"
            (click)="this[action.clickMethod]()"

          >
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
          </button>
        </ng-container>
    </div>
  </div>
  <form [formGroup]="detailForm">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="40px">
        <mat-form-field
          *ngIf="columnsVisible.get('id')"
          [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label> {{ "raster-category.id" | translate }} </mat-label>
          <input
            matInput
            [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="id"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('name')"
          [ngStyle]="{
            'width.ch': detailForm.controls['name'].value ? detailForm.controls['name'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label>{{ "raster-category.name" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['name'].value ? detailForm.controls['name'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="name"
          />
          <mat-error *ngIf="detailForm.controls['name'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
        </mat-form-field>

        <app-type-of-raster-dropdown *ngIf="columnsVisible.get('code')"
          (selectedChange)="this.setSelectedTypeOfRaster($event)"
          [required]="true"
          [singleSelection]="true"
          [selected]="this.preSelectedTypeOfRaster"
        ></app-type-of-raster-dropdown>

        <mat-form-field *ngIf="this.id !== 'new' && columnsVisible.get('code_disabled')" [ngStyle]="{
          'width.ch': detailForm.controls['code_disabled'].value ? detailForm.controls['code_disabled'].value.length : 10,
          'min-width.px': 300
       }">
           <mat-label>{{ "raster-category.code" | translate }}</mat-label>
           <input matInput [ngStyle]="{
           'width.ch': detailForm.controls['code_disabled'].value ? detailForm.controls['code_disabled'].value.length : 10,
           'min-width.px': 300
       }"
       formControlName="code_disabled" />
         </mat-form-field>

      </div>

      <div fxLayout="row wrap" fxLayoutGap="40px">
        <mat-form-field
        *ngIf="columnsVisible.get('colorMap')"
        [ngStyle]="{
            'width.ch': 300,
            'max-width.px': 300
          }">
          <mat-label>{{ 'raster-category.color-map' | translate }}</mat-label>
          <textarea
            id="colorMap"
            matInput
            class="form-control"
            [ngStyle]="{
              'width.ch':  200,
              'max-width.px': 200
            }"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="4"
            cols="10"
            formControlName="colorMap"
          ></textarea>
        </mat-form-field>

        <app-legend [colorMap]="this.detailForm.controls['colorMap'] ? this.detailForm.controls['colorMap'].value : ''">
        </app-legend>

      </div>
    </div>

      <mat-accordion multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'raster-category.explanation' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
            <mat-panel-description>
              <blockquote [ngStyle]="{
                'width.ch': 500,
                'max-width.px': 500
              }">
                <p>The text-based color configuration file generally contains 4 columns per line: the elevation value and the corresponding Red, Green, Blue component (between 0 and 255). The elevation value can be any floating point value, or the nv keyword for the nodata value. The elevation can also be expressed as a percentage: 0% being the minimum value found in the raster, 100% the maximum value.</p>
                <p>An extra column can be optionally added for the alpha component. If it is not specified, full opacity (255) is assumed.</p>
                <p>Various field separators are accepted: comma, tabulation, spaces, ‘:’.</p>
                <p>Common colors used by GRASS can also be specified by using their name, instead of the RGB triplet. The supported list is: white, black, red, green, blue, yellow, magenta, cyan, aqua, grey/gray, orange, brown, purple/violet and indigo.</p>
                <p>GMT .cpt palette files are also supported (COLOR_MODEL = RGB only).</p>
                <p>Note: the syntax of the color configuration file is derived from the one supported by GRASS r.colors utility. ESRI HDR color table files (.clr) also match that syntax. The alpha component and the support of tab and comma as separators are GDAL specific extensions.</p>
                </blockquote>
              </mat-panel-description>
          </mat-expansion-panel>
        <mat-expansion-panel *ngIf="this.id !== 'new'" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'log-messages.title' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
            <mat-panel-description>
          <app-log-messages-list [modelId]="this.id" [ngStyle]="{
            'width.pc': 100
          }"></app-log-messages-list>
          </mat-panel-description>
        </mat-expansion-panel>


      </mat-accordion>



  </form>



